import React from 'react';
import PropTypes from 'prop-types';

import { formatYear } from '@zr/common/js/profile/formatters';
import ExpandableText from '@zr/components/ExpandableText';
import { getSortedSection } from '@zr/jobseeker-public/apps/jobseeker-profile/utilities';

export function EducationSection({ headingLevel, educations }) {
  const Heading = headingLevel;

  return (
    <section className="education employer_profile_section">
      <Heading className="title">Education</Heading>
      <ol>
        {getSortedSection(educations).map((edu, index) => (
          <li className="item" key={`${index.toString()}edu`}>
            <h3 className="item_title">
              {edu.school}
            </h3>
            <div className="subheadlines">
              <h4 className="subheadline">
                <span className="subhead">
                  {edu.name}
                  {' '}
                  {edu.major}
                </span>
                {(edu.start_date || edu.end_date || edu.current) && (
                  <span className="dates">
                    {edu.start_date && (
                      <time dateTime={edu.start_date}>
                        {formatYear(edu.start_date)}
                      </time>
                    )}
                    {(edu.start_date && !!(edu.end_date || edu.current)) && ' - '}
                    {!!(edu.end_date || edu.current) && (
                      <time dateTime={edu.end_date}>
                        {edu.current ? 'In Progress' : formatYear(edu.end_date)}
                      </time>
                    )}
                  </span>
                )}
              </h4>
            </div>
            {!!edu.description && <ExpandableText className="description" text={edu.description} />}
          </li>
        ))}
      </ol>
    </section>
  );
}

EducationSection.propTypes = {
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
  educations: PropTypes.arrayOf(PropTypes.shape({
    school: PropTypes.string,
    name: PropTypes.string,
    major: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    current: PropTypes.bool,
    description: PropTypes.string,
  })).isRequired,
};

export default EducationSection;
